import React, { ReactNode } from 'react';

interface MetricCardProps {
    icon: ReactNode;
    title: string;
    value?: number | string;
    bgColor: string;
    textColor: string;
    /**
     * Anuncia una función que todavía no está disponible: en lugar del dato
     * muestra un distintivo "Próximamente". La tarjeta se mantiene visible a
     * propósito — enseña lo que viene, en vez de esconderlo o de mostrar un 0
     * que parece un error.
     */
    comingSoon?: boolean;
}

const MetricCard: React.FC<MetricCardProps> = ({
    icon,
    title,
    value,
    bgColor,
    textColor,
    comingSoon = false,
}) => {
    // En "próximamente" el distintivo ocupa TODO el ancho de la tarjeta en vez de
    // ir junto al icono: no cabe al lado (la columna de texto se queda en ~108 px
    // en una rejilla de 4 columnas) y quedaba recortado.
    if (comingSoon) {
        return (
            <div
                className={`${bgColor} rounded-lg shadow-md p-4 text-gray-400`}
                aria-label={`${title} — próximamente`}
            >
                <div className="flex items-center">
                    <div className="mr-4 shrink-0">{icon}</div>
                    <h3 className="text-sm font-medium leading-tight opacity-80">{title}</h3>
                </div>
                {/* Sin padding horizontal a propósito: `w-full` ya da el ancho y
                    la caja de contenido de la tarjeta se queda en ~102 px en la
                    rejilla de 4 columnas (Bootstrap hace que `p-4` sean 24 px por
                    lado, no 16). Con `px-*` el texto no cabía y se salía. */}
                <span className="mt-3 block w-full whitespace-nowrap rounded-full bg-amber-100 py-1.5 text-center text-[13px] font-bold leading-tight text-amber-800">
                    Próximamente
                </span>
            </div>
        );
    }

    return (
        <div className={`${bgColor} ${textColor} rounded-lg shadow-md p-4 flex items-center`}>
            <div className="mr-4 shrink-0">{icon}</div>
            <div className="min-w-0">
                <h3 className="text-sm font-medium leading-tight opacity-80">{title}</h3>
                <p className="text-2xl font-bold">{value}</p>
            </div>
        </div>
    );
};

export default MetricCard;
